export default "__VITE_ASSET__CLzGQhBr__"